import React, { useEffect, useState } from 'react';

import { KuposSuccessFailure } from '../../../common';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

function Thankyoupage({ match, history, t }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const success = match.params.status === 'success';
  const [ticketDetails, setTicketDetails] = useState({ coupon_pdf_link: '' });

  return (
    <div className="home-thankyou-page">
      <KuposSuccessFailure
        t={t}
        success={success}
        title={
          success
            ? i18next.language == 'es'
              ? '¡Listo!'
              : 'All set!'
            : i18next.language == 'es'
            ? '¡Lo sentimos!'
            : "We're sorry"
        }
        subtitle={
          success
            ? i18next.language == 'es'
              ? 'La compra de tu cuponera fue procesada con éxito. Te enviaremos los detalles de tu compra a tu correo electrónico. Si no lo consigues, recuerda revisar tu bandeja de correo no deseado o spam.'
              : "Your purchase was processed succesfully. We sent you all the transaction details to your email account. If you can't find it, don't forget to take a look at your spam folder."
            : i18next.language == 'es'
            ? 'Tu compra no pudo ser procesada. Por favor intenta nuevamente o contáctanos a nuestros canales de atención para asistirte en tu compra.'
            : "Something went wrong with your purchase and we couldn't process it correctly."
        }
        infoText={
          success
            ? i18next.language == 'es'
              ? '¡Gracias por comprar con nosotros!'
              : 'Thanks for choosing us!'
            : i18next.language == 'es'
            ? 'Por favor intenta nuevamente'
            : 'Please try again one more time!'
        }
      >
         {success ? ( 
       
          <div className="successful-purchase-buttons font12">
            {/* <button
              className="kupos-button active"
              onClick={() => {
                window.open(ticketDetails.coupon_pdf_link, '_blank');
              }}
            >
              <span>{i18next.language == 'es' ? 'Descargar CUPONERA' : 'Download COUPONS'}</span>
            </button> */}
             <button
              className="kupos-button2 no-underline-hover"
              style={{ textDecoration: 'none' }}
              onClick={() => history.push(`/${i18next.language}/pages/contact`)}
            >
              {i18next.language == 'es' ? 'Contáctanos' : 'Contact us'}
            </button>
            <button onClick={() => history.push('/my-account')} className="kupos-button active">
              {i18next.language == 'es' ? 'Mis Cuponera' : 'My Cupons'}
            </button>
          </div>
        ) : (
          <div className="successful-purchase-buttons font12">
            <button
              className="kupos-button2 no-underline-hover"
              style={{ textDecoration: 'none' }}
              onClick={() => history.push(`/${i18next.language}/pages/contact`)}
            >
              {i18next.language == 'es' ? 'Contáctanos' : 'Contact us'}
            </button>
            <button onClick={() => history.push('/')} className="kupos-button active">
              {i18next.language == 'es' ? 'Volver al inicio' : 'Back to top'}
            </button>
          </div>
        )}
      </KuposSuccessFailure>
    </div>
  );
}

export default withTranslation('common')(Thankyoupage);



// WEBPACK FOOTER //
// ./src/features/home/Cuponera/Thankyou/ThankyouPage.js